import * as React from 'react';
import {
  List,
  Datagrid,
  Filter,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  DateInput,
  TextField,
  DateField,
  ReferenceField,
  ReferenceInput,
} from 'react-admin';

const useTxtData = {
  table: {
    id: 'id',
    S_xumu_id: '畜牧',
    bianhao: '档案编号',
    pinzhong: '品种',
    rulan_time: '入栏时间',
    chulan_time: '出栏时间',
    rulan_tizhong: '入栏体重',
    chulan_tizhong: '出栏体重',
  }
};

export const S_xumu_jiazhiList = (props) => (
  <List {...props} filters={<Filters />}>
    <Datagrid>
      <TextField label={useTxtData.table.id} source="id" />
      <ReferenceField label={useTxtData.table.S_xumu_id} source="S_xumu_id" reference="Admin/CMSS_xumu">
        <TextField source="name" />
      </ReferenceField>
      <TextField label={useTxtData.table.bianhao} source="bianhao" />
      <TextField label={useTxtData.table.pinzhong} source="pinzhong" />
      <DateField label={useTxtData.table.rulan_time} source="rulan_time" showTime />
      <DateField label={useTxtData.table.chulan_time} source="chulan_time" showTime />
      <TextField label={useTxtData.table.rulan_tizhong} source="rulan_tizhong" />
      <TextField label={useTxtData.table.chulan_tizhong} source="chulan_tizhong" />
    </Datagrid>
  </List>
);

const Filters = (props) => (
  <Filter {...props}>
    <TextInput label="档案编号" source="bianhao" alwaysOn />
    <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

export const S_xumu_jiazhiEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.bianhao} source="bianhao" />
      <TextInput label={useTxtData.table.pinzhong} source="pinzhong" />
      <DateInput label={useTxtData.table.rulan_time} source="rulan_time" />
      <DateInput label={useTxtData.table.chulan_time} source="chulan_time" />
      <NumberInput label={useTxtData.table.rulan_tizhong} source="rulan_tizhong" />
      <NumberInput label={useTxtData.table.chulan_tizhong} source="chulan_tizhong" />
    </SimpleForm>
  </Edit>
);

export const S_xumu_jiazhiCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput label="畜牧" source="S_xumu_id" reference="Admin/CMSS_xumu">
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput label={useTxtData.table.bianhao} source="bianhao" />
      <TextInput label={useTxtData.table.pinzhong} source="pinzhong" />
      <DateInput label={useTxtData.table.rulan_time} source="rulan_time" />
      <DateInput label={useTxtData.table.chulan_time} source="chulan_time" />
      <NumberInput label={useTxtData.table.rulan_tizhong} source="rulan_tizhong" />
      <NumberInput label={useTxtData.table.chulan_tizhong} source="chulan_tizhong" />
    </SimpleForm>
  </Create>
);